import { Card, Flex, Heading, Text } from '@radix-ui/themes';
import { ErrorBoundary } from 'components/common/error-boundary';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { ReactNode } from 'react';

export const SubSectionBox = (props: {
  title: string;
  source: string;
  children: ReactNode;
}) => (
  <ErrorBoundary identifier={props.source}>
    <Card className="no-background">
      <Flex direction="column" gap={RADIX.FLEX.GAP.XS} mb={RADIX.FLEX.GAP.XS}>
        <Heading size={RADIX.HEADING.SIZE.SM}>{props.title}</Heading>
        <Text size={RADIX.TEXT.SIZE.SM} color={RADIX.COLOR.NEUTRAL}>
          {props.source}
        </Text>
      </Flex>

      {props.children}
    </Card>
  </ErrorBoundary>
);
